import user from './modules/user';
import cart from './modules/cart';
import batchCart from './modules/batch-cart';
import address from './modules/address';
import confirmOrder from './modules/confirm-order';
import invitationActivity from './modules/invitation-activity';
import platformPhone from './modules/platform-phone';

export default {
  data () {
    return {
      user,
      cart,
      batchCart,
      address,
      confirmOrder,
      invitationActivity,
      platformPhone
    }
  }
}